import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "row" };
const _hoisted_2 = { class: "col-auto" };
const _hoisted_3 = { class: "form-check mb-3 mb-lg-0" };
const _hoisted_4 = { class: "form-check mb-3 mb-lg-0" };
const _hoisted_5 = { class: "col-auto" };
const _hoisted_6 = { class: "input-group mb-3 mb-lg-0" };
const _hoisted_7 = { class: "form-floating" };
const _hoisted_8 = { class: "input-group-text" };
const _hoisted_9 = { class: "col-auto d-flex align-items-center" };
const _hoisted_10 = { class: "form-check mb-3 mb-lg-0" };
const _hoisted_11 = { class: "col-auto" };
const _hoisted_12 = { class: "form-floating mb-3 mb-lg-0" };
import { onMounted, ref } from 'vue';
import { responseMessages } from '@/Composables/responseMessages';
import axios from 'axios';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ProductPriceAddition',
    props: {
        bottle: {
            type: Object,
            required: false
        },
        lid: {
            type: Object,
            required: false
        },
        package: {
            type: Object,
            required: false
        },
        // accessoryProduct: Object,
        //TODO: other relation types
    },
    setup(__props) {
        let { showErrorMessage, showSuccessMessage } = responseMessages();
        const props = __props;
        const relationType = ref(null);
        const relationUuid = ref(null);
        const productPriceAdditionForm = ref({
            value: null,
            percentage: null,
            active: true,
            note: null
        });
        onMounted(() => {
            if (props.bottle) {
                relationType.value = 'bottles';
                relationUuid.value = props.bottle.uuid;
            }
            if (props.lid) {
                relationType.value = 'lids';
                relationUuid.value = props.lid.uuid;
            }
            if (props.package) {
                relationType.value = 'packages';
                relationUuid.value = props.package.uuid;
            }
            //TODO: other relation types
            loadLastProductPriceAddition();
        });
        function loadLastProductPriceAddition() {
            axios.post(route('admin.productPriceAdditions.load', relationUuid.value), {
                type: relationType.value
            }).then((response) => {
                if (response.data.productPriceAddition != null) {
                    productPriceAdditionForm.value.value = response.data.productPriceAddition.value;
                    productPriceAdditionForm.value.percentage = response.data.productPriceAddition.percentage;
                    productPriceAdditionForm.value.active = response.data.productPriceAddition.active;
                    productPriceAdditionForm.value.note = response.data.productPriceAddition.note;
                }
            }).catch((error) => {
                showErrorMessage(error);
            });
        }
        function updatePriceAddition() {
            if (relationUuid.value == null) {
                return;
            }
            axios.post(route('admin.' + relationType.value + '.productPriceAdditions.update', relationUuid.value), {
                value: productPriceAdditionForm.value.value,
                percentage: productPriceAdditionForm.value.percentage,
                active: productPriceAdditionForm.value.active,
                note: productPriceAdditionForm.value.note
            }).then((response) => {
                showSuccessMessage('Aufschlag gespeichert');
            }).catch((error) => {
                showErrorMessage(error);
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _cache[11] || (_cache[11] = _createElementVNode("p", null, "Ein aktiver Preisaufschlag wird auf den Einzelpreis eines Produkts angerechnet und überschreibt Lieferanten-Aufschläge.", -1)),
                _createElementVNode("form", {
                    onSubmit: _withModifiers(updatePriceAddition, ["prevent"])
                }, [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "radio",
                                    name: "valueType",
                                    id: "valueTypeFixed",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((productPriceAdditionForm.value.percentage) = $event)),
                                    value: false,
                                    required: ""
                                }, null, 512), [
                                    [_vModelRadio, productPriceAdditionForm.value.percentage]
                                ]),
                                _cache[5] || (_cache[5] = _createElementVNode("label", {
                                    class: "form-check-label",
                                    for: "valueTypeFixed"
                                }, "Fester Betrag", -1))
                            ]),
                            _createElementVNode("div", _hoisted_4, [
                                _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "radio",
                                    name: "valueType",
                                    id: "valueTypePercentage",
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((productPriceAdditionForm.value.percentage) = $event)),
                                    value: true,
                                    required: ""
                                }, null, 512), [
                                    [_vModelRadio, productPriceAdditionForm.value.percentage]
                                ]),
                                _cache[6] || (_cache[6] = _createElementVNode("label", {
                                    class: "form-check-label",
                                    for: "valueTypePercentage"
                                }, "Prozentualer Betrag", -1))
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _withDirectives(_createElementVNode("input", {
                                        id: "newPrice",
                                        type: "number",
                                        class: "form-control",
                                        min: "0",
                                        step: "0.01",
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((productPriceAdditionForm.value.value) = $event)),
                                        required: ""
                                    }, null, 512), [
                                        [_vModelText, productPriceAdditionForm.value.value]
                                    ]),
                                    _cache[7] || (_cache[7] = _createElementVNode("label", { for: "newPrice" }, "Wert", -1))
                                ]),
                                _createElementVNode("span", _hoisted_8, _toDisplayString(productPriceAdditionForm.value.percentage ? '%' : '€'), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                                _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    value: true,
                                    id: "priceAdditionActive",
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((productPriceAdditionForm.value.active) = $event))
                                }, null, 512), [
                                    [_vModelCheckbox, productPriceAdditionForm.value.active]
                                ]),
                                _cache[8] || (_cache[8] = _createElementVNode("label", {
                                    class: "form-check-label",
                                    for: "priceAdditionActive"
                                }, "Aktiv", -1))
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    class: "form-control",
                                    id: "priceAdditionNote",
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((productPriceAdditionForm.value.note) = $event))
                                }, null, 512), [
                                    [_vModelText, productPriceAdditionForm.value.note]
                                ]),
                                _cache[9] || (_cache[9] = _createElementVNode("label", { for: "priceAdditionNote" }, "Notiz (optional)", -1))
                            ])
                        ]),
                        _cache[10] || (_cache[10] = _createStaticVNode("<div class=\"col-auto d-flex align-items-center\"><button type=\"submit\" class=\"btn btn-success d-inline-flex align-items-center\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" fill=\"currentColor\" class=\"bi bi-check2\" viewBox=\"0 0 16 16\"><path d=\"M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0\"></path></svg><span class=\"ms-2\">Speichern</span></button></div>", 1))
                    ])
                ], 32)
            ]));
        };
    }
});
